import { Baby, Dog, Heart, Stethoscope } from "lucide-react";
import { IMG } from "@/lib/site";
import PageHero from "@/components/PageHero";
import SectionHeading from "@/components/SectionHeading";
import CtaSection from "@/components/CtaSection";

const fasce = [
  { icon: Baby, t: "Cuccioli", d: "Crescita equilibrata, nutrienti specifici per i primi mesi." },
  { icon: Dog, t: "Cani adulti", d: "Mantenimento ottimale, energia per la vita di tutti i giorni." },
  { icon: Heart, t: "Cani anziani", d: "Formule più digeribili e supporto articolare." },
  { icon: Stethoscope, t: "Esigenze particolari", d: "Soluzioni per intolleranze, allergie e diete specifiche." },
];

export default function Cibo() {
  return (
    <div data-testid="page-cibo">
      <PageHero
        overline="Alimentazione per cani"
        title="Prodotti selezionati e consigli su misura"
        lead="Una corretta alimentazione è il primo passo per il benessere quotidiano del tuo cane. Ti aiutiamo a scegliere il prodotto più adatto."
        image={IMG.cibo}
        primaryCta={{ to: "/contatti", label: "Chiedi informazioni" }}
        secondaryCta={{ to: "/negozio", label: "Vai al negozio" }}
      />

      <section className="py-16 sm:py-24" data-testid="importanza">
        <div className="max-w-5xl mx-auto px-6 sm:px-10 lg:px-12 reveal">
          <SectionHeading
            overline="L'importanza della giusta alimentazione"
            title="Ogni cane ha bisogni diversi."
            lead="Età, taglia, stile di vita e condizioni specifiche cambiano le esigenze nutrizionali: il prodotto giusto può fare davvero la differenza."
          />
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-[#EDD895]/60" data-testid="prodotti">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 reveal">
            <div className="aspect-[4/3] rounded-3xl overflow-hidden">
              <img src={IMG.cibo} alt="Cibo per cani" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="lg:col-span-6 reveal">
            <SectionHeading
              overline="Prodotti selezionati"
              title="Qualità in cui ci fidiamo, anche per i nostri cani."
            />
            <ul className="mt-7 space-y-3 text-[#6B5F4A]">
              {[
                "Crocchette di qualità per ogni taglia ed età",
                "Alimenti umidi e specialità",
                "Snack e premi per l'addestramento",
                "Diete specifiche e soluzioni veterinarie",
                "Integratori per il mantello e le articolazioni",
              ].map((p) => (
                <li key={p} className="flex gap-3">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#7A1F1F] flex-none" />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24" data-testid="fasce">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12">
          <SectionHeading overline="Per ogni fase della vita" title="Una soluzione per ogni età." />
          <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {fasce.map((f, i) => (
              <div
                key={f.t}
                className="reveal bg-[#F5E6C0] border border-[#D9C48A] rounded-3xl p-7"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="w-12 h-12 rounded-2xl bg-[#EDD895] grid place-items-center mb-5 text-[#8B4A2B]">
                  <f.icon className="w-6 h-6" strokeWidth={1.4} />
                </div>
                <h4 className="font-sans font-semibold text-[#1A1710] text-lg">{f.t}</h4>
                <p className="mt-2 text-sm text-[#6B5F4A] leading-relaxed">{f.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaSection
        title="Non sai quale prodotto scegliere?"
        lead="Vieni a trovarci o scrivici: ti consigliamo l'alimento più adatto alle esigenze del tuo cane."
        primaryLabel="Chiedi consiglio"
      />
    </div>
  );
}
